import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useGetCurrentModuleQuery } from 'src/features/dashboard/dashboard.slice';

import { useGetUserQuery, useTrackEventMutation } from '../slices';

export const useRepairStreak = () => {
  const { data: userData } = useGetUserQuery();
  const navigate = useNavigate();
  const { data: currentRoomsData } = useGetCurrentModuleQuery(undefined, { skip: !userData?.data?.user?._id });
  const incompleteRoom = currentRoomsData?.data?.find(({ progress }) => progress < 100);
  const incompleteRoomCode = incompleteRoom?.code;
  const redirectPath = incompleteRoomCode ? `/room/${incompleteRoomCode}` : '/hacktivities';

  const [trackEvent] = useTrackEventMutation();

  const repairStreakHandler = useCallback(() => {
    // eslint-disable-next-line no-void
    void trackEvent({
      event: 'cta-streak-repair',
    });
    navigate(redirectPath);
  }, [navigate, trackEvent, redirectPath]);

  return repairStreakHandler;
};
